import PropTypes from 'prop-types';

export const rightsShape = PropTypes.shape({
  fastForward: PropTypes.bool.isRequired,
  pause: PropTypes.bool.isRequired,
  rewind: PropTypes.bool.isRequired,
  seek: PropTypes.bool.isRequired,
  adsPause: PropTypes.bool.isRequired,
  adsRewind: PropTypes.bool.isRequired,
  adsFastForward: PropTypes.bool.isRequired,
});

export const bufferedShape = PropTypes.shape({
  start: PropTypes.number,
  end: PropTypes.number,
});

export const viewableEpisodeMetadataShape = PropTypes.shape({
  title: PropTypes.string.isRequired,
  seasonNumber: PropTypes.number.isRequired,
  episodeNumber: PropTypes.number.isRequired,
});

export const viewableMetadataShape = PropTypes.shape({
  banner: PropTypes.string,
  title: PropTypes.string.isRequired,

  // for progress bar
  start: PropTypes.number,
  stop: PropTypes.number,

  episode: viewableEpisodeMetadataShape,
});

export const metadataShape = PropTypes.shape({
  banner: PropTypes.string,
  title: PropTypes.string,
});

export const errorShape = PropTypes.shape({
  code: PropTypes.number.isRequired,
  errorMessage: PropTypes.shape({
    message: PropTypes.string.isRequired,
    values: PropTypes.object,
  }).isRequired,
});

export const ratingShape = PropTypes.shape({
  name: PropTypes.string,
  image: PropTypes.string,
  reasons: PropTypes.arrayOf(PropTypes.string),
});
